import React, {FC} from 'react';

import {ITableActionProps} from 'components/table/action';
import {ActionButton} from 'components/table/action/action-button';
import {selectEntityData} from 'modules/data';
import {resetData} from 'modules/data/data-actions';
import {ITableEntityData} from 'modules/data/data-types';
import {EEntityType} from 'shared/constants/entities';
import {performRequest, showMessageFromResponse } from 'shared/utils';
import {useQueryParams} from 'shared/utils/query-params';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {TAppState} from 'store/config/types';
import {normalizeEntityName} from 'utils/common';

export const ButtonSendRequestCopyResponseRequirement: FC<ITableActionProps> = ({
    meta,
    entityName,
    wrapper,
    ...props
}: ITableActionProps) => {
    const dispatch = useAppDispatch()
    const {selectedRowKeys = []} = useAppSelector(
        (state: TAppState) => (
            selectEntityData(entityName, EEntityType.TABLE)(state) || {}
        ) as ITableEntityData,
    );
    const {getQueryParam} = useQueryParams();
    const docId = getQueryParam('docId');
    
    const handleClick = async () => {        
        try {
            const response = await performRequest({
                url: meta.referenceUrl,
                method: meta.requestType,
                data: {
                    ids: selectedRowKeys,
                    docId
                },
            });
    
            showMessageFromResponse({response})
            dispatch(resetData({
                entityType: meta?.parentEntityType || EEntityType.TABLE,
                entityName: normalizeEntityName(entityName),
                loading: false,
              }));
        } catch (e) {
            console.error(e);
            showMessageFromResponse({response: e.response, isError: true});
        }
    };

    const Component = wrapper || ActionButton;
    return (
        <Component
            {...props}
            onClick={handleClick}
            actionIcon={meta.actionIcon}
            disabled={!selectedRowKeys.length}
        >
            {meta.actionTitle}
        </Component>
    );
};
